import { useParam } from "@blitzjs/next"
import { useMutation } from "@blitzjs/rpc"
import { SModal, SFlex, SButton } from "@superwall-me/sui"
import { useRouter } from "next/router"
import { useState } from "react"
import { useTemplateJsonContext } from "../contexts/JsonProvider"
import { initialJson } from "../contexts/JsonProvider/JsonProvider"
import { usePaywallBuilderContext } from "../contexts/PaywallBuilderProvider"
import createPaywallTemplate from "../mutations/createPaywallTemplateV2"
import tw from "tailwind-styled-components"
import _ from "lodash"
import { escapeSpecialCharsInTemplateJson } from "app/paywalls/helpers/escapeSpecialCharsInTemplateJson"

const Container = tw.div`
  border-b
  border-white
  border-opacity-7
  py-4
`

const getSubstring = (str, start = "", end = "") => {
  if (!str) return
  return str.substring(str.indexOf(start) + start.length, str.lastIndexOf(end))
}

export const getBuilderVersion = (paywallURL: string) => {
  return getSubstring(paywallURL, "/release/", "/base2/template.html")
}

const Actions = () => {
  const router = useRouter()
  const { mode, onClosePaywallBuilder, paywall } = usePaywallBuilderContext()
  const { parsedJson, setJson } = useTemplateJsonContext()
  const applicationId = useParam("applicationId", "number")!
  const { url: paywallURL } = paywall || {}

  const builderVersion = getBuilderVersion(paywallURL || "")

  const [isModalOpen, setIsModalOpen] = useState(false)

  const [createPaywallTemplateMutation] = useMutation(createPaywallTemplate)

  const onCreatePaywallTemplate = async () => {
    const newParsedJson = escapeSpecialCharsInTemplateJson({ parsedJson })

    const { url } = await createPaywallTemplateMutation({
      applicationId,
      json: newParsedJson,
      url: paywallURL || null,
    })

    if (url) {
      router.push(
        `/applications/${applicationId}/paywalls/new/template?url=${encodeURIComponent(url)}`
      )
    }
  }

  const onResetJson = () => {
    const resetJson = true
    setJson(initialJson, resetJson)
    setIsModalOpen(false)
  }

  const onUpdateTemplate = async () => {
    let parsedJsonCopy = _.cloneDeep(parsedJson)

    const newParsedJson = escapeSpecialCharsInTemplateJson({ parsedJson: parsedJsonCopy })

    const { url } = await createPaywallTemplateMutation({
      applicationId,
      json: newParsedJson,
      url: paywallURL || null,
      builderVersion,
    })

    onClosePaywallBuilder && onClosePaywallBuilder(url)
  }

  const onCloseBuilder = (url?: string) => {
    onClosePaywallBuilder && onClosePaywallBuilder(url)
  }

  return (
    <>
      <Container>
        <SFlex justify="end" align="center" gap="4">
          {mode === "create" ? (
            <>
              <SButton onClick={onCreatePaywallTemplate}>Create Paywall</SButton>
              <SButton onClick={() => setIsModalOpen(true)} variant="secondary">
                Reset Template
              </SButton>
            </>
          ) : (
            <>
              <SButton onClick={onUpdateTemplate}>Update Template</SButton>
              <SButton onClick={() => onCloseBuilder()} variant="secondary">
                Close
              </SButton>
            </>
          )}
        </SFlex>
      </Container>
      <SModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <SModal.Content onClose={() => setIsModalOpen(false)}>
          <SModal.Title>Reset Current Template?</SModal.Title>

          <SFlex gap="3">
            <SButton onClick={() => setIsModalOpen(false)} className="mt-2 w-full">
              Cancel
            </SButton>
            <SButton onClick={onResetJson} className="mt-2 w-full" variant="secondary">
              Reset
            </SButton>
          </SFlex>
        </SModal.Content>
      </SModal>
    </>
  )
}

export default Actions
